import React from 'react';
import { getIn } from 'formik';
import { InputRemoteSelect } from '../Select';
import { useFetchForRemoteSelect } from '../../../hooks';

const RemoteSelectFilter = ({
  indexRequest,
  debouncedIndexRequest,
  fieldName,
  label,
  customParams,
  setCustomParams,
  requestParams,
  ...props
}) => {
  const { data, selectedOption, fetchOptions } = useFetchForRemoteSelect({
    indexRequest,
    debouncedIndexRequest,
    value: getIn(customParams, fieldName),
    ...(requestParams && { initialParams: requestParams })
  });

  const handleRemoteChange = selected => {
    setCustomParams(params => ({
      ...params,
      [fieldName]: selected?.value || ''
    }));
  };

  return (
    <InputRemoteSelect
      isClearable
      defaultOption={data}
      value={selectedOption}
      request={fetchOptions}
      onChange={selected => handleRemoteChange(selected)}
      {...props}
    />
  );
};

export default RemoteSelectFilter;
